import { isObject, LeafFieldPath } from "@redotech/util/type";

export function updatedObject<T extends object>(
  object: T,
  path: LeafFieldPath<T>,
  value: unknown,
): T {
  const fields = String(path).split(".");

  const updateAtPath = (
    currentObject: unknown,
    fieldIndex: number,
  ): unknown => {
    if (!isObject(currentObject)) {
      return currentObject;
    }

    const field = fields[fieldIndex];
    if (field === undefined) {
      return currentObject;
    }

    if (fieldIndex === fields.length - 1) {
      return { ...currentObject, [field]: value };
    }

    const currentValue = currentObject[field];
    const updatedValue = updateAtPath(currentValue, fieldIndex + 1);

    if (updatedValue === currentValue) {
      return currentObject;
    }

    return { ...currentObject, [field]: updatedValue };
  };

  const newObject = updateAtPath(object, 0);
  // The typed path guarantees that a successful update preserves T; the
  // runtime traversal uses unknown because its keys are dynamic.
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  return newObject === object ? { ...object } : (newObject as T);
}
